/*eslint-disable*/
import React from 'react'
import { Col } from "react-bootstrap";
import { orange } from '../../utils/constants'
import { error } from './style'

export function renderInputWithSearchField(field) {

  const onSearch = field.onsearch
  const imageIcon = field.loading ? 'fa fa-spinner fa-spin' : "fa fa-search"
  
  return (
    <div className='form-group'>
      <label className={field.labelattrs}>{field.label}</label>
      <Col className={field.inputattrs}>
        <input
          className={`form-control  ${field.className}`}
          placeholder={field.placeholder ? field.placeholder : ''}
          type={field.type ? field.type : 'text'}
          {...field.input}
          style={{ borderRadius: '4px 0 0 4px' }}
          disabled={field.disabled}
        />
        {field.meta.touched && field.meta.error && <span style={error}>*{field.meta.error}</span>}
      </Col>
      <Col sm={1} lg={1} md={1}>
        <span className="input-group-btn" sm={1} md={1} lg={1}>
          <button
            type="button"

            className="btn btn-default"
            id={field.buttonid}
            style={{ marginLeft: '-31px', marginTop: '-1px', minHeight: '37px', maxWidth: '41px', borderRadius: '0 4px 4px 0', color: orange }}
            onClick={onSearch}
            disabled={field.buttondisabled || field.disabled}>
            <i className={imageIcon} aria-hidden="true" />
          </button>
        </span>
      </Col>
    </div>)
}


// WEBPACK FOOTER //
// ./src/modules/components/inputwithsearchfieldcomponent.js